module.exports = __webpack_public_path__ + "static/media/kolo.d16e6d52.png";